import ModernAnalyticsListener from './ModernAnalyticsListener';
export default ModernAnalyticsListener;